import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import PropTypes from 'prop-types';
import Geocode from 'react-geocode';
import { ChildrenPropType } from '../../services/proptypes';
import { calculateDistance } from '../../utils/geo';
export var LOCATION_STATUS = {
  IDLE: 0,
  WAITING_FOR_USER_LOCATION: 1,
  CALCULATING_DIST: 2,
  FINISHED: 3,
  LOCATION_UNAVAILABLE: 4
};
var GeoClosestLocation = /*#__PURE__*/function (_React$Component) {
  _inherits(GeoClosestLocation, _React$Component);
  var _super = _createSuper(GeoClosestLocation);
  function GeoClosestLocation(props) {
    var _this;
    _classCallCheck(this, GeoClosestLocation);
    _this = _super.call(this, props);
    Geocode.setApiKey(process.env.GOOGLE_MAPS_API_KEY);
    if (process.env.NODE_ENV === 'development') {
      Geocode.enableDebug();
    }
    _this.state = {
      loading: false,
      locationStatus: LOCATION_STATUS.IDLE,
      locationsWithDistance: props.locations.map(function (l) {
        return _objectSpread(_objectSpread({}, l), {}, {
          fullAddress: GeoClosestLocation.getFullAddress(l)
        });
      })
    };
    _this.hasUsersLocation = _this.hasUsersLocation.bind(_assertThisInitialized(_this));
    _this.doesNotHaveUsersLocation = _this.doesNotHaveUsersLocation.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(GeoClosestLocation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var start = this.props.start;
      if (start) {
        this.getUsersLocation();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldStart = prevProps.start;
      var newStart = this.props.start;
      var locationStatus = this.state.locationStatus;
      if (newStart && !oldStart && locationStatus === LOCATION_STATUS.IDLE) {
        this.getUsersLocation();
      }
    }
  }, {
    key: "getUsersLocation",
    value: function getUsersLocation() {
      if ('geolocation' in navigator) {
        this.setState({
          loading: true,
          locationStatus: LOCATION_STATUS.WAITING_FOR_USER_LOCATION
        });
        navigator.geolocation.getCurrentPosition(this.hasUsersLocation, this.doesNotHaveUsersLocation);
      } else {
        this.setState({
          loading: false,
          locationStatus: LOCATION_STATUS.LOCATION_UNAVAILABLE
        });
      }
    }
  }, {
    key: "doesNotHaveUsersLocation",
    value: function doesNotHaveUsersLocation() {
      this.setState({
        loading: false,
        locationStatus: LOCATION_STATUS.LOCATION_UNAVAILABLE
      });
    }
  }, {
    key: "hasUsersLocation",
    value: function () {
      var _hasUsersLocation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(position) {
        var _this$props, locations, distanceUnit, userLat, userLong, locationsWithDistance, _iterator, _step, location, fullAddress, distance, results, _results$results$0$ge, lat, lng;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, locations = _this$props.locations, distanceUnit = _this$props.distanceUnit;
              this.setState({
                loading: true,
                locationStatus: LOCATION_STATUS.CALCULATING_DIST
              });
              userLat = position.coords.latitude;
              userLong = position.coords.longitude;
              locationsWithDistance = []; // eslint-disable-next-line no-restricted-syntax
              _iterator = _createForOfIteratorHelper(locations);
              _context.prev = 6;
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context.next = 24;
                break;
              }
              location = _step.value;
              fullAddress = GeoClosestLocation.getFullAddress(location);
              distance = -1;
              _context.prev = 12;
              _context.next = 15;
              return Geocode.fromAddress(fullAddress);
            case 15:
              results = _context.sent;
              if (results) {
                _results$results$0$ge = results.results[0].geometry.location, lat = _results$results$0$ge.lat, lng = _results$results$0$ge.lng;
                distance = calculateDistance(lat, lng, userLat, userLong, distanceUnit);
              }
              _context.next = 21;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](12);
            case 21:
              locationsWithDistance.push(_objectSpread(_objectSpread({}, location), {}, {
                fullAddress: fullAddress,
                distance: distance,
                distanceUnit: distanceUnit
              }));
            case 22:
              _context.next = 8;
              break;
            case 24:
              _context.next = 29;
              break;
            case 26:
              _context.prev = 26;
              _context.t1 = _context["catch"](6);
              _iterator.e(_context.t1);
            case 29:
              _context.prev = 29;
              _iterator.f();
              return _context.finish(29);
            case 32:
              locationsWithDistance.sort(function (a, b) {
                if (a.distance === -1) return 1;
                if (b.distance === -1) return -1;
                return a.distance > b.distance ? 1 : -1;
              });
              this.setState({
                loading: false,
                locationStatus: LOCATION_STATUS.FINISHED,
                locationsWithDistance: locationsWithDistance
              });
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 26, 29, 32], [12, 19]]);
      }));
      function hasUsersLocation(_x) {
        return _hasUsersLocation.apply(this, arguments);
      }
      return hasUsersLocation;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        loading = _this$state.loading,
        locationStatus = _this$state.locationStatus,
        locationsWithDistance = _this$state.locationsWithDistance;
      var children = this.props.children;
      return children({
        state: locationStatus,
        locations: locationsWithDistance,
        loading: loading
      });
    }
  }], [{
    key: "getFullAddress",
    value: function getFullAddress(location) {
      return "".concat(location.street, ", ").concat(location.city, ", ").concat(location.state, " ").concat(location.zip);
    }
  }]);
  return GeoClosestLocation;
}(React.Component);
export { GeoClosestLocation as default };
GeoClosestLocation.propTypes = {
  start: PropTypes.bool,
  distanceUnit: PropTypes.oneOf(['M', 'K']),
  locations: PropTypes.arrayOf(PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    zip: PropTypes.string
  })),
  children: ChildrenPropType.isRequired
};
GeoClosestLocation.defaultProps = {
  start: false,
  distanceUnit: 'M',
  locations: []
};